"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.customization")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.customization", {
            url: "/customizacao/:source?",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-customization" */ "./customization.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.customization")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "customizationComponent",
                    bindings: { companyData: "CompanyData" }
                },
                params: {
                    source: {
                        value: null,
                        dynamic: true
                    }
                }
            }
        })
        .state("nucont.accounting.company.customization.indicators", {
            url: "/indicadores",
            views: {
                "customizationType@nucont.accounting.company.customization": {
                    component: "indicatorsComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        })
        .state("nucont.accounting.company.customization.graphics", {
            url: "/grafico",
            params: {
                openDialogAdd: {
                    value: null,
                    dynamic: true
                }
            },
            views: {
                "customizationType@nucont.accounting.company.customization": {
                    component: "chartsCustomizationComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            resolve: {
                source: [
                    "$stateParams",
                    ($stateParams) => {
                        return $stateParams.source;
                    }
                ]
            },
            bodyClass: "customization-module"
        })
        .state("nucont.accounting.company.customization.dashboards", {
            url: "/dashboards",
            views: {
                "customizationType@nucont.accounting.company.customization": {
                    component: "customDashboardsComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        });
}
